// @ts-nocheck
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Text from "../Text/Text";
var LangSelector = function(param) {
    var currentLang = param.currentLang, langs = param.langs, color = param.color, setLang = param.setLang, _dropdownPosition = param.dropdownPosition, dropdownPosition = _dropdownPosition === void 0 ? "bottom" : _dropdownPosition, _buttonScale = param.buttonScale, buttonScale = _buttonScale === void 0 ? "md" : _buttonScale, _hideLanguage = param.hideLanguage, hideLanguage = _hideLanguage === void 0 ? false : _hideLanguage;
    return /*#__PURE__*/ _jsx(Text, {});
};
export default /*#__PURE__*/ React.memo(LangSelector, function(prev, next) {
    return prev.currentLang === next.currentLang;
});
